// ##### 25-02-05 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import MenuBar from '../../../Library/Icons/menubar';
import MenuClose from '../../../Library/Icons/menuclose';

// ##### Komarov 2025-07-14
const SmallScreensNavBarButton = ({ className, toggle, translate }) => {
  // ##### 24-03-21 Komarov
  return (
    <button
      type="button"
      className={className}
      onClick={toggle}
      data-component="SmallScreensNavBarButton"
    >
      {' '}
      {translate ? (
        <span className="CloseMenuIcon">
          <MenuClose />
        </span>
      ) : (
        <span className="MenuButtonIcon">
          <MenuBar />
        </span>
      )}
    </button>
  );
};

export default SmallScreensNavBarButton;
